const globalApiHosts = {
	dev: 'https://api.d.nexon.io',
	testPre: 'https://test-pre-api.nexon.io',
	test: 'https://test-api.nexon.io',
	pre: 'https://pre-api.nexon.io',
	prod: 'https://api.nexon.io',
};

export default {
	globalApiHost: globalApiHosts[process.env.NODE_ENV],
};



// WEBPACK FOOTER //
// ./src/config/api-host.js